import React from 'react';
export function VineyardSection() {
  return <section className="relative w-full h-[350px] md:h-[400px] lg:h-[500px] bg-cover bg-center bg-fixed" style={{
    backgroundImage: 'url(https://assets.modern-commerce.io/Glenlofty%20Project%20Files/lucinda-wang-nMWMsOowOyc-unsplash.jpg)'
  }} data-id="element-170">
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/40" data-id="element-171" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6" data-id="element-172">
        <div className="max-w-[900px] text-center" data-id="element-173">
          {/* Eyebrow */}
          <span className="block text-[14px] font-optima font-semibold uppercase tracking-[0.15em] text-gold mb-6" data-id="element-174">
            Our Vineyard
          </span>

          {/* Headline */}
          <h2 className="text-[32px] md:text-[36px] lg:text-[48px] font-optima font-semibold text-white leading-[1.2] mb-8" data-id="element-175">
            Cool-Climate Pyrenees
          </h2>

          {/* Body Copy */}
          <p className="text-[16px] md:text-[17px] lg:text-[18px] font-optima text-white/95 leading-[1.7] mb-10" data-id="element-176">
            Located approximately 1,000 feet above sea level in the Pyrenees
            foothills, Glenlofty is a true cool-climate site by Australian
            standards. Significant diurnal variation preserves acidity and
            structure. Independent AWRI data identifies Glenlofty as one of the
            coolest sites in the Pyrenees.
          </p>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-3 mt-10" data-id="element-177">
            <div className="text-[16px] font-optima text-white/85" data-id="element-178">
              ~140 hectares under vine
            </div>
            <div className="text-[16px] font-optima text-white/85" data-id="element-179">
              30 individual vineyard blocks
            </div>
            <div className="text-[16px] font-optima text-white/85" data-id="element-180">
              Low yields: 4–5 tonnes/hectare
            </div>
            <div className="text-[16px] font-optima text-white/85" data-id="element-181">
              Certified organic
            </div>
          </div>
        </div>
      </div>
    </section>;
}